"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { Short } from "@/components/short";
import { URLSearchParamsToStr } from "@/lib/type-safe-stringify";
import { cn } from "@/lib/utils";
import { useScrollToTop } from "./scroll-to-top-provider";
interface ReferralProps {
  referral: string | null;
  affiliates: string[] | undefined;
  className?: string;
  length?: number;
}
export function Referral(t0) {
  const $ = _c(18);
  const {
    referral,
    affiliates,
    className,
    length: t1
  } = t0;
  const length = t1 === undefined ? 24 : t1;
  const pathname = usePathname();
  const {
    scrollToTop
  } = useScrollToTop();
  let t2;
  if ($[0] !== pathname || $[1] !== referral) {
    t2 = referral !== null ? (() => {
      const params = new URLSearchParams();
      params.set("referral", referral);
      return `${pathname}?${URLSearchParamsToStr(params)}`;
    })() : undefined;
    $[0] = pathname;
    $[1] = referral;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const link = t2;
  let t3;
  if ($[3] !== referral) {
    t3 = referral?.trim();
    $[3] = referral;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const trimmedReferral = t3;
  const t4 = trimmedReferral === undefined || trimmedReferral === "" ? "1Click" : trimmedReferral;
  const t5 = referral !== null ? "cursor-pointer" : "cursor-default";
  let t6;
  if ($[5] !== className || $[6] !== t5) {
    t6 = cn(t5, "border-brand-orange text-brand-orange rounded-full border px-2 py-1 text-[10px] font-normal", className);
    $[5] = className;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== affiliates || $[9] !== referral) {
    t7 = getTooltipText(referral, affiliates);
    $[8] = affiliates;
    $[9] = referral;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== length || $[12] !== link || $[13] !== scrollToTop || $[14] !== t4 || $[15] !== t6 || $[16] !== t7) {
    t8 = <Short text={t4} showCopy={false} length={length} className={t6} link={link} linkClassName="text-inherit" tooltipText={t7} onInternalLinkClick={scrollToTop} scroll={false} />;
    $[11] = length;
    $[12] = link;
    $[13] = scrollToTop;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function getTooltipText(referral: string | null, affiliates: string[] | undefined) {
  let tooltipText = "1Click API transaction";
  if (referral !== null) {
    tooltipText += ` with referral: ${referral}`;
  }
  if (affiliates !== undefined && affiliates.length > 0) {
    const affiliateText = `affiliates: ${affiliates.join(", ")}`;
    if (referral !== null) {
      tooltipText += ` and ${affiliateText}`;
    } else {
      tooltipText += ` with ${affiliateText}`;
    }
  }
  return tooltipText;
}